import { _ as T, g as v, H as w, h as _ } from "./CardVideo-e725a421.js";
import { resolveComponent as r, resolveDirective as x, openBlock as l, createElementBlock as m, createElementVNode as i, toDisplayString as C, createCommentVNode as n, withDirectives as b, createBlock as s, resolveDynamicComponent as M, normalizeClass as P, vModelDynamic as E, createVNode as y, withCtx as D, renderSlot as S, normalizeStyle as I, withModifiers as B } from "vue";
import { _ as V } from "./_plugin-vue_export-helper-dad06003.js";
import { X as F } from "./XIcon-e21df3cc.js";
import "./glightbox-13d8fc52.js";
import { A as H } from "./AlertCircleIcon-61966fff.js";
import { H as N } from "./HelpIcon-2069ddad.js";
import { M as A } from "./MagnifyingGlassIcon-14c73a3f.js";
import { M as L } from "./MailIcon-b92e5b55.js";
import { C as Y, P as R } from "./PhoneIcon-9b24c2d8.js";
import { c as O, f as U } from "./string-30844d53.js";
import { useNotificationHandler as X } from "./useNotificationHandler.js";
import "./FormRichText.model-53e072ea.js";
const G = {
  components: {
    FormNotification: T,
    AlertCircleIcon: H,
    HelpIcon: N,
    MailIcon: L,
    MagnifyingGlassIcon: A,
    CalendarIcon: Y,
    PhoneIcon: R
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    error: {
      type: String,
      default: ""
    },
    help: {
      type: String,
      default: ""
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    tooltip: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    pattern: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue", "blur"],
  setup(t) {
    return X(t);
  },
  data() {
    return {
      id: v()
    };
  },
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(t) {
        O({ value: t, pattern: this.pattern }) && this.$emit(
          "update:modelValue",
          U({ value: t, pattern: this.pattern, field: this.$refs.input })
        );
      }
    }
  },
  mounted() {
    this.autofocus && this.$refs.input.focus();
  }
}, q = { "data-scroll": "" }, z = ["for"], j = {
  key: 0,
  class: "ct-text-error"
}, J = { class: "relative mt-2 rounded-lg shadow-sm shadow-gray-900/5" }, K = { class: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3" }, Q = ["id", "type", "placeholder", "disabled"], W = {
  key: 0,
  class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
};
function Z(t, o, e, c, p, a) {
  const f = r("HelpIcon"), h = r("AlertCircleIcon"), d = r("FormNotification"), u = x("tooltip");
  return l(), m("div", q, [
    i("label", {
      for: p.id,
      class: "flex items-center text-sm font-medium leading-6 ct-text-2 space-x-1"
    }, [
      i("span", null, C(e.title), 1),
      e.required ? (l(), m("span", j, "*")) : n("", !0),
      e.tooltip ? b((l(), s(f, {
        key: 1,
        class: "cursor-pointer ct-fg-4 h-4 w-4"
      }, null, 512)), [
        [u, { content: e.tooltip }]
      ]) : n("", !0)
    ], 8, z),
    i("div", J, [
      i("div", K, [
        (l(), s(M(e.icon), {
          class: "h-5 w-5 ct-fg-4",
          "aria-hidden": "true"
        }))
      ]),
      b(i("input", {
        id: p.id,
        ref: "input",
        "onUpdate:modelValue": o[0] || (o[0] = (g) => a.model = g),
        type: e.type,
        class: P(["ct-input ct-input--icon", { "is-error": t.hasError }]),
        placeholder: e.placeholder,
        disabled: e.disabled,
        onBlur: o[1] || (o[1] = (g) => t.$emit("blur", g))
      }, null, 42, Q), [
        [E, a.model]
      ]),
      t.hasError ? (l(), m("div", W, [
        y(h, {
          class: "h-4 w-4 text-error-500 dark:text-error-400",
          "aria-hidden": "true"
        })
      ])) : n("", !0)
    ]),
    t.hasHelp ? (l(), s(d, {
      key: 0,
      message: e.help,
      help: ""
    }, {
      default: D(() => [
        S(t.$slots, "help")
      ]),
      _: 3
    }, 8, ["message"])) : n("", !0),
    t.hasError ? (l(), s(d, {
      key: 1,
      message: e.error,
      error: ""
    }, {
      default: D(() => [
        S(t.$slots, "error")
      ]),
      _: 3
    }, 8, ["message"])) : n("", !0)
  ]);
}
const $ = /* @__PURE__ */ V(G, [["render", Z]]), k = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit"
};
function ee(t) {
  const o = {
    "01": "MM",
    1: "M",
    16: "DD",
    2025: "YYYY",
    10: "HH",
    55: "mm"
  }, e = new Date(2025, 0, 16, 10, 55);
  return (t ? e.toLocaleDateString([], k) : e.toLocaleString()).replace(/\d{1,4}/g, (c) => o[c] || c);
}
const te = {
  name: "FormInputDate",
  components: {
    XIcon: F,
    VueDatePicker: w,
    FormInputPreIcon: $
  },
  props: {
    modelValue: {
      type: [String, Date],
      default: ""
    },
    lang: {
      type: String,
      default: "en"
    },
    title: {
      type: String,
      default: "Date"
    },
    error: {
      type: String,
      default: ""
    },
    help: {
      type: String,
      default: ""
    },
    tooltip: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    enableTimePicker: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    canReset: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue", "valueAsDate"],
  data() {
    return { debounceTextValue: 0 };
  },
  computed: {
    chosenDate: {
      get() {
        return this.modelValue ? new Date(this.modelValue) : null;
      },
      set(t) {
        const o = t === null ? "" : _(t).format("YYYY-MM-DDTHH:mm");
        this.$emit("update:modelValue", o), this.$emit("valueAsDate", t);
      }
    },
    chosenDateString() {
      return this.chosenDate ? this.enableTimePicker ? this.chosenDate.toLocaleString([], k) : this.chosenDate.toLocaleDateString() : "";
    }
  },
  methods: {
    setDateByString(t) {
      clearTimeout(this.debounceTextValue);
      const o = ee(this.enableTimePicker), e = _(t, o);
      t || (this.chosenDate = null), e.isValid() && (this.debounceTextValue = setTimeout(() => {
        this.chosenDate = e.toDate();
      }, 2e3));
    }
  }
};
function oe(t, o, e, c, p, a) {
  const f = r("FormInputPreIcon"), h = r("XIcon"), d = r("VueDatePicker");
  return l(), s(d, {
    modelValue: a.chosenDate,
    "onUpdate:modelValue": o[1] || (o[1] = (u) => a.chosenDate = u),
    "enable-time-picker": e.enableTimePicker,
    "action-row": { showCancel: !1, showSelect: !1, showPreview: !1 },
    "month-name-format": "long",
    locale: e.lang,
    position: "left",
    "auto-apply": "",
    disabled: e.disabled,
    clearable: e.canReset
  }, {
    trigger: D(() => [
      y(f, {
        "model-value": a.chosenDateString,
        icon: "CalendarIcon",
        title: e.title,
        error: e.error,
        help: e.help,
        disabled: e.disabled,
        placeholder: e.placeholder,
        tooltip: e.tooltip,
        class: "cursor-pointer",
        "onUpdate:modelValue": a.setDateByString
      }, null, 8, ["model-value", "title", "error", "help", "disabled", "placeholder", "tooltip", "onUpdate:modelValue"]),
      e.canReset && a.chosenDate ? (l(), m("button", {
        key: 0,
        class: "absolute right-5 top-9 w-2 h-2",
        style: I({ marginRight: e.error ? "20px" : "" })
      }, [
        y(h, {
          class: "mt-2 w-3.5 text-gray-400 dark:text-neutral-500 ct-bg-1--hover",
          style: I({ pointerEvents: e.disabled ? "none" : "auto" }),
          onClick: o[0] || (o[0] = B((u) => a.chosenDate = null, ["stop"]))
        }, null, 8, ["style"])
      ], 4)) : n("", !0)
    ]),
    _: 1
  }, 8, ["modelValue", "enable-time-picker", "locale", "disabled", "clearable"]);
}
const ge = /* @__PURE__ */ V(te, [["render", oe]]);
export {
  $ as F,
  ge as a
};
